import { FC, useState } from 'react';
import { Box, Button, Grid } from '@mui/material';
import CampaignCsvUploadModal from './CampaignCsvUploadModal/CampaignCsvUploadModal';
import Tab from '@mui/material/Tab';
import { TabContext, TabList, TabPanel } from '@mui/lab';

const CampaignsPage: FC = () => {
  const [selectedTab, setSelectedTab] = useState('1');
  const [isCsvUploadModalOpen, setIsCsvUploadModalOpen] = useState(false);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <Box paddingX={1} paddingTop={1}>
      <TabContext value={selectedTab}>
        <TabList onChange={handleTabChange}>
          <Tab label="Upload CSV Campaign" value="1" />
        </TabList>
        <TabPanel value="1">
          <Grid item xs={12}>
            <Box mt={2}>
              <Button variant="contained" sx={{ mr: 2 }} onClick={() => setIsCsvUploadModalOpen(true)}>
                Upload CSV Campaign
              </Button>
            </Box>
            <CampaignCsvUploadModal isOpen={isCsvUploadModalOpen} onClose={() => setIsCsvUploadModalOpen(false)} />
          </Grid>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default CampaignsPage;
